export default function selfServeJobs(state = { performingJob: false, jobProgressId: -1, currentJobProgress: 0, currentJobTotalParts: 0, jobs: [], histories: [], globalFiles: [], jobFilesPage: 1, jobsPage: 1, historiesPage: 1 }, action) {
    switch (action.type) {
        case 'SELF_SERVICE_INDEX':
            return {
                ...state, performingJob: false, jobProgressId: -1, currentJobProgress: 0, currentJobTotalParts: 0,
            }
        case 'SELF_SERVICE_JOB_START':
            return {
                ...state, performingJob: true, jobProgressId: action.jobID, currentJobProgress: 0, currentJobTotalParts: 5,
            }
        case 'SELF_SERVICE_JOB_PROGRESS':
            return {
                ...state, performingJob: true, jobProgressId: action.jobID, currentJobProgress: action.progress, currentJobTotalParts: action.total,
            }
        case 'SELF_SERVICE_DATABASE_JOBS':
            return {
                ...state, jobs: action.payload,
            }
        case 'SELF_SERVICE_DATABASE_JOB_HISTORIES':
            return {
                ...state, histories: action.payload,
            }
        case 'SELF_SERVICE_DATABASE_JOB_FILES':
            return {
                ...state, globalFiles: action.payload,
            }
        case 'SELF_SERVICE_JOB_FILES_PAGE_CHANGE':
            return {
                ...state, jobFilesPage: action.pageNumber,
            }
        case 'SELF_SERVICE_JOB_PAGE_CHANGE':
            return {
                ...state, jobsPage: action.pageNumber,
            }
        case 'SELF_SERVICE_JOB_HISTORIES_CHANGE':
            return {
                ...state, historiesPage: action.pageNumber,
            }
        default:
            return state
    }
}